export default __webpack_public_path__ + "static/media/bg2.0432a3fc.png";